import Service from '@ekd/portal-connector/dist/Service';
import { getEnv } from '../../../common/utils/getEnv';
import { dataLoader } from '../../../libs/redis/dataloader/dataLoader';
import { AxiosRequestConfig } from 'axios';

type ServiceVariables = {
  domain: string;
};

class FeedService extends Service {
  /**
   * Fetch feed
   */
  public async fetch({ domain }: { domain: string }) {
    try {
      const dataLoaderOptions = {
        local: {
          cache: true,
        },
        remote: {
          expireTimeMs: 60000, // 30 seconds
          gracePeriodMs: 24 * 3600 * 1000, // 24 hours
          keyPrefix: 'channel_feed',
        },
        locker: {
          maxLockPeriod: 3000,
          lockInterval: 1000,
        },
        cacheKeyFn: () => {
          return `site_${domain}`;
        },
      };

      const options = {
        url: getEnv('feedApi'),
        params: {
          ch: domain,
        },
        timeout: 3000,
      };

      const requestWrapper = (options: AxiosRequestConfig) => {
        const apiProvider = this.createProvider('HTTP');
        return apiProvider.request<Response>(options);
      };

      const redisDataLoader = dataLoader<AxiosRequestConfig, Response>(requestWrapper, dataLoaderOptions);
      const feed: Response = redisDataLoader ? await redisDataLoader.load(options) : await requestWrapper(options);

      if (!feed) {
        return null;
      }

      return { domain, feed };
    } catch {
      return null;
    }
  }
}

export const feedService = new FeedService();

export function fetchFrontpageService(variables: ServiceVariables, { req }: { req: PortalRootIncomingMessage }) {
  const feedService = new FeedService({ req });
  return feedService.fetch(variables);
}
